export type RecentSale = {
  id: string;
  projectId: number;
  prosjekt: string;
  enhet: string | null;
  enhetBeskrivelse: string | null;
  pris: number | null;
  m2: number | null;
  solgt: string | null;
  registrert: string | null;
  kjoper: string | null;
  kjoper2: string | null;
};

export async function fetchRecentSales(days = 30): Promise<RecentSale[]> {
  const res = await fetch(`/api/sales/recent?days=${days}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = (await res.json()) as { sales: RecentSale[] };
  return data.sales ?? [];
}
